import styled, { css } from "styled-components";
import { getBreakpoint } from "../../../../../common-deprecated/themes/common";
import { theme as lexusTheme } from "../theme/lexusTheme";

export const Wrapper = styled.section<{ height?: number | null; top?: number | null }>`
    ${({ height, top }) =>
        height &&
        top &&
        css`
            position: fixed;
            top: ${top}px;
            left: 0;
            right: 0;
            height: ${height}px;
            z-index: ${lexusTheme.zIndex.overlay};
            @media ${getBreakpoint("up", "md")} {
                top: 100%;
                height: initial;
            }
        `}
    color: ${lexusTheme.colors.azure};
    background-color: ${lexusTheme.colors.silver};
    overflow: hidden;
`;

export const Panel = styled.div<{ top?: number | null }>`
    position: relative;
    width: 100vw;
    overflow: hidden;
`;

// total width and left offset can are calculated dynamically so this component can be used with both 2 and 3 panels
// 184px is the height of the SelectPane Footer on mobile
export const Panels = styled.div<{
    currentPanel?: number;
    panelCount?: number;
    height?: number | null;
    compareHeaderHeight?: number | null;
}>`
    display: flex;
    width: ${({ panelCount }) => (panelCount || 1) * 100}%;
    transform: ${({ currentPanel, panelCount, theme }) =>
        `translateX(${theme.isRTL ? "" : "-"}${((currentPanel || 0) * 100) / (panelCount || 1)}%)`};
    transition: transform 0.25s ease-in-out;

    ${({ compareHeaderHeight, height }) =>
        compareHeaderHeight &&
        css`
            ${Panel} {
                /* 166px is the height of the footer */
                max-height: calc(${height}px - ${compareHeaderHeight}px - 166px);
                @media ${getBreakpoint("up", "md")} {
                    max-height: 250px;
                }
            }
        `}
`;
